import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import ReactDatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { generateDefaultValues, schema, Schema } from "./schema";
import {
  ProjectsLocationsData,
  UpdateProjectLocationPayload
} from "../../../../../../models/ProjectData";
import { HookForm } from "../../../../../HookForm/HookForm";

import "./styles.scss";

interface IProjectJoinDateFormProps {
  projectLocation: ProjectsLocationsData;
  handleClose: () => void;
  handleSubmit: (payload: UpdateProjectLocationPayload) => void;
}

export const ProjectJoinDateForm: React.FC<IProjectJoinDateFormProps> = ({
  projectLocation,
  handleClose,
  handleSubmit
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `projectManagementPage.projectFacilityDetailsModal.projectJoinDate.${key}`
    );

  const form = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues: generateDefaultValues(projectLocation)
  });

  const onSubmit = async (data: Schema) => {
    const payload = {
      project_join_date: data.projectJoinDate
    };
    handleSubmit(payload);
  };

  return (
    <div className="modal modal-default modal-project-join-date-form">
      <div className="modal-mains">
        <button className="btn-close" onClick={handleClose}></button>
        <div className="modal-mains__body">
          <HookForm
            form={form}
            onSubmit={onSubmit}
            onCancel={handleClose}
            showCancelButton
          >
            <div>
              <Controller
                control={form.control}
                name="projectJoinDate"
                render={({ field }) => (
                  <div className="registered-date-input-container">
                    <label
                      className="hook-form-input-label"
                      htmlFor={field.name}
                    >
                      {t("registered")}
                    </label>
                    <ReactDatePicker
                      locale="ja"
                      dateFormat="yyyy/MM/dd"
                      selected={field.value}
                      onChange={field.onChange}
                      className="registered-date-input"
                    />
                  </div>
                )}
              />
            </div>
          </HookForm>
        </div>
      </div>
    </div>
  );
};
